import { Component, OnInit } from '@angular/core';
import { Ng2IzitoastService } from 'ng2-izitoast';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { V4Service } from 'src/app/services/v4.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-v2-productos',
  templateUrl: './v2-productos.component.html',
  styleUrls: ['./v2-productos.component.scss']
})
export class V2ProductosComponent implements OnInit {
  productos: any[] = [];
  filtro = '';
  filtroTipo = '';
  filtroActivo = '';
  readonly tiposProductoBase = ['Marco', 'Moldura', 'Color', 'Placa', 'Cuadro'];
  tiposProductoCatalogo: any[] = [];
  filtroTipoCatalogo = '';
  formulario = { nombre: '', tipo: '', descripcion: '', activo: 1, imagen: null as File | null };
  formularioEdit = { id: 0, nombre: '', tipo: '', descripcion: '', activo: 1, imagen: null as File | null };
  tipoForm = { nombre: '', descripcion: '', activo: 1 };
  tipoDestino: 'nuevo' | 'editar' = 'nuevo';

  variaciones: any[] = [];
  variacionesBase: any[] = [];
  variacionesSeleccionadas: number[] = [];
  filtroVariacion = '';
  filtroVariacionBase = '';
  productoSeleccionado: any = null;
  productoConfiguraciones: any[] = [];
  productoVariacionConfigurando: any = null;
  configuracionProductoInput = '';
  configuracionProductoSeleccionada: number | null = null;
  filtroConfiguracionProducto = '';
  loadingProductoConfiguraciones = false;

  imagenesProducto: any[] = [];
  productoImagenFiles: File[] = [];
  productoImagenForm = { titulo: '', orden: 0, activo: 1 };
  loadingImagenes = false;
  loading = false;

  private readonly defaultImage = 'assets/img/auri_logo.png';
  private tipoModalRef: NgbModalRef | null = null;

  constructor(
    private v4: V4Service,
    private iziToast: Ng2IzitoastService,
    private modalService: NgbModal
  ) {}

  ngOnInit(): void {
    this.getTiposProductoCatalogo();
    this.getProductos();
    this.getVariacionesBase();
  }

  getProductos(): void {
    this.loading = true;
    this.v4.getProductos().subscribe(
      (data: any) => {
        this.loading = false;
        if (data.success) {
          this.productos = data.content || [];
        }
      },
      (error) => {
        this.loading = false;
        console.error(error);
      }
    );
  }

  get productosFiltrados() {
    const term = this.filtro.toLowerCase();
    const tipo = this.filtroTipo.toLowerCase();
    return this.productos.filter((p) => {
      const nombre = (p.nombre || '').toLowerCase();
      const descripcion = (p.descripcion || '').toLowerCase();
      const tipoProducto = (p.tipo || '').toLowerCase();
      const matchTexto = !term || nombre.includes(term) || descripcion.includes(term) || tipoProducto.includes(term);
      const matchTipo = !tipo || tipoProducto.includes(tipo);
      const matchActivo = this.filtroActivo === '' || String(p.activo === 0 ? 0 : 1) === String(this.filtroActivo);
      return matchTexto && matchTipo && matchActivo;
    });
  }

  get tiposProductos() {
    return this.getTiposProducto();
  }

  getTiposProducto(tipoActual?: string): string[] {
    const tipos = this.tiposProductoCatalogo.length ? [] : [...this.tiposProductoBase];
    const agregarTipo = (tipo?: string) => {
      const valor = (tipo || '').trim();
      if (valor && !tipos.some((item) => item.toLowerCase() === valor.toLowerCase())) {
        tipos.push(valor);
      }
    };

    this.tiposProductoCatalogo.forEach((tipo) => agregarTipo(tipo.nombre));
    this.productos.forEach((producto) => agregarTipo(producto.tipo));
    agregarTipo(tipoActual);

    return tipos;
  }

  get tiposProductoCatalogoFiltrados() {
    const term = this.filtroTipoCatalogo.toLowerCase();
    return this.tiposProductoCatalogo.filter((tipo) => {
      const nombre = (tipo.nombre || '').toLowerCase();
      const descripcion = (tipo.descripcion || '').toLowerCase();
      return !term || nombre.includes(term) || descripcion.includes(term);
    });
  }

  abrirAgregarTipo(modal: any, destino: 'nuevo' | 'editar' = 'nuevo'): void {
    this.tipoDestino = destino;
    this.tipoForm = { nombre: '', descripcion: '', activo: 1 };
    this.filtroTipoCatalogo = '';
    this.tipoModalRef = this.modalService.open(modal, { ariaLabelledBy: 'modal-agregar-tipo-producto' });
  }

  agregarTipoProducto(): void {
    const nombre = this.tipoForm.nombre.trim();
    if (!nombre) {
      this.toast('Nombre requerido', '#CA0B00');
      return;
    }
    if (this.getTiposProducto().some((tipo) => tipo.toLowerCase() === nombre.toLowerCase())) {
      this.aplicarTipoNuevo(nombre);
      this.toast('Tipo ya existe');
      this.tipoModalRef?.close();
      this.tipoModalRef = null;
      return;
    }

    this.v4.crearTipoProducto({
      nombre,
      descripcion: this.tipoForm.descripcion,
      activo: this.tipoForm.activo
    }).subscribe(
      (data: any) => {
        if (data.success) {
          const tipoCreado = data.content || { nombre };
          this.tiposProductoCatalogo.push(tipoCreado);
          this.ordenarTiposCatalogo();
          this.aplicarTipoNuevo(tipoCreado.nombre || nombre);
          this.toast('Tipo creado');
          this.tipoModalRef?.close();
          this.tipoModalRef = null;
        } else {
          this.toast(this.getApiError(data) || 'No se pudo crear tipo', '#CA0B00');
        }
      },
      (error) => console.error(error)
    );
  }

  eliminarTipoProducto(tipo: any): void {
    if (!tipo?.id || !confirm('Eliminar tipo?')) {
      return;
    }
    this.v4.eliminarTipoProducto(tipo.id).subscribe(
      (data: any) => {
        if (data.success) {
          this.tiposProductoCatalogo = this.tiposProductoCatalogo.filter((item) => Number(item.id) !== Number(tipo.id));
          if ((this.formulario.tipo || '').toLowerCase() === (tipo.nombre || '').toLowerCase()) {
            this.formulario.tipo = '';
          }
          if ((this.formularioEdit.tipo || '').toLowerCase() === (tipo.nombre || '').toLowerCase()) {
            this.formularioEdit.tipo = '';
          }
          this.toast('Tipo eliminado');
        } else {
          this.toast(this.getApiError(data) || 'No se pudo eliminar tipo', '#CA0B00');
        }
      },
      (error) => console.error(error)
    );
  }

  agregarProducto(): void {
    if (!this.formulario.nombre.trim()) {
      this.toast('Nombre requerido', '#CA0B00');
      return;
    }
    this.v4.crearProducto({
      nombre: this.formulario.nombre,
      tipo: this.formulario.tipo,
      descripcion: this.formulario.descripcion,
      activo: this.formulario.activo,
      imagen: this.formulario.imagen
    }).subscribe(
      (data: any) => {
        if (data.success) {
          this.toast('Producto creado');
          this.formulario = { nombre: '', tipo: '', descripcion: '', activo: 1, imagen: null };
          this.getProductos();
        }
      },
      (error) => console.error(error)
    );
  }

  abrirEditar(modal: any, producto: any): void {
    this.formularioEdit = {
      id: producto.id,
      nombre: producto.nombre || '',
      tipo: producto.tipo || '',
      descripcion: producto.descripcion || '',
      activo: producto.activo === 0 ? 0 : 1,
      imagen: null
    };
    this.modalService.open(modal, { ariaLabelledBy: 'modal-editar-producto' });
  }

  actualizarProducto(): void {
    this.v4.actualizarProducto(this.formularioEdit.id, {
      nombre: this.formularioEdit.nombre,
      tipo: this.formularioEdit.tipo,
      descripcion: this.formularioEdit.descripcion,
      activo: this.formularioEdit.activo,
      imagen: this.formularioEdit.imagen
    }).subscribe(
      (data: any) => {
        if (data.success) {
          this.toast('Producto actualizado');
          this.modalService.dismissAll();
          this.formularioEdit = { id: 0, nombre: '', tipo: '', descripcion: '', activo: 1, imagen: null };
          this.getProductos();
        }
      },
      (error) => console.error(error)
    );
  }

  toggleProductoActivo(producto: any): void {
    const activo = producto.activo === 0 ? 1 : 0;
    this.v4.actualizarProducto(producto.id, {
      nombre: producto.nombre,
      tipo: producto.tipo || '',
      descripcion: producto.descripcion || '',
      activo
    }).subscribe(
      (data: any) => {
        if (data.success) {
          producto.activo = activo;
          this.toast(activo ? 'Producto activado' : 'Producto desactivado');
        }
      },
      (error) => console.error(error)
    );
  }

  eliminarProducto(id: number): void {
    if (!confirm('Eliminar producto?')) {
      return;
    }
    this.v4.eliminarProducto(id).subscribe(
      (data: any) => {
        if (data.success) {
          this.toast('Producto eliminado');
          this.getProductos();
        }
      },
      (error) => console.error(error)
    );
  }

  getVariaciones(producto: any): void {
    this.productoSeleccionado = producto;
    this.v4.getVariaciones(producto.id).subscribe(
      (data: any) => {
        if (data.success) {
          this.variaciones = data.content || [];
          const asignadas = this.variaciones.map((variacion) => Number(variacion.variacion));
          this.variacionesSeleccionadas = this.variacionesSeleccionadas.filter((id) => !asignadas.includes(Number(id)));
        }
      },
      (error) => console.error(error)
    );
  }

  abrirVariaciones(modal: any, producto: any): void {
    this.variacionesSeleccionadas = [];
    this.filtroVariacion = '';
    this.filtroVariacionBase = '';
    this.productoSeleccionado = producto;
    this.getVariaciones(producto);
    this.modalService.open(modal, { ariaLabelledBy: 'modal-variaciones', size: 'lg' });
  }

  agregarVariacion(): void {
    const ids = [...this.variacionesSeleccionadas];
    if (!this.productoSeleccionado || !ids.length) {
      this.toast('Seleccione variacion', '#CA0B00');
      return;
    }

    let pendientes = ids.length;
    let agregadas = 0;
    const finalizar = () => {
      pendientes -= 1;
      if (pendientes === 0) {
        if (agregadas > 0) {
          this.toast('Variaciones agregadas');
        }
        this.variacionesSeleccionadas = [];
        this.getVariaciones(this.productoSeleccionado);
      }
    };

    ids.forEach((variacionId) => {
      this.v4.crearVariacion({
        producto: this.productoSeleccionado.id,
        variacion: variacionId,
        activo: 1
      }).subscribe(
        (data: any) => {
          if (data.success) {
            agregadas += 1;
          } else {
            this.toast(typeof data.error === 'string' ? data.error : 'No se pudo agregar variacion', '#CA0B00');
          }
          finalizar();
        },
        (error) => {
          console.error(error);
          finalizar();
        }
      );
    });
  }

  toggleVariacionProducto(variacion: any): void {
    const activo = variacion.activo === 0 ? 1 : 0;
    this.v4.actualizarVariacion(variacion.id, {
      producto: variacion.producto || this.productoSeleccionado?.id,
      variacion: variacion.variacion,
      activo
    }).subscribe(
      (data: any) => {
        if (data.success) {
          variacion.activo = activo;
          this.toast(activo ? 'Variacion activa' : 'Variacion inactiva');
        }
      },
      (error) => console.error(error)
    );
  }

  eliminarVariacion(id: number): void {
    if (!confirm('Eliminar variacion del producto?')) {
      return;
    }
    this.v4.eliminarVariacion(id).subscribe(
      (data: any) => {
        if (data.success) {
          this.toast('Variacion eliminada');
          this.getVariaciones(this.productoSeleccionado);
        }
      },
      (error) => console.error(error)
    );
  }

  configurarVariacionProducto(variacion: any): void {
    this.productoVariacionConfigurando = variacion;
    this.configuracionProductoInput = '';
    this.configuracionProductoSeleccionada = null;
    this.filtroConfiguracionProducto = '';
    this.loadProductoConfiguraciones();
  }

  loadProductoConfiguraciones(): void {
    if (!this.productoSeleccionado || !this.productoVariacionConfigurando) {
      this.productoConfiguraciones = [];
      return;
    }
    this.loadingProductoConfiguraciones = true;
    this.v4.getProductoConfiguraciones(this.productoSeleccionado.id, {
      variacion: this.productoVariacionConfigurando.variacion
    }).subscribe(
      (data: any) => {
        this.loadingProductoConfiguraciones = false;
        if (data.success) {
          this.productoConfiguraciones = data.content || [];
        }
      },
      (error) => {
        this.loadingProductoConfiguraciones = false;
        console.error(error);
      }
    );
  }

  agregarConfiguracionProducto(): void {
    const configuracionId = this.configuracionProductoSeleccionada || this.getConfiguracionIdFromInput(this.configuracionProductoInput);
    if (!this.productoSeleccionado || !this.productoVariacionConfigurando || !configuracionId) {
      this.toast('Seleccione configuracion', '#CA0B00');
      return;
    }
    this.v4.crearProductoConfiguracion({
      producto: this.productoSeleccionado.id,
      configuracion: configuracionId,
      activo: 1
    }).subscribe(
      (data: any) => {
        if (data.success) {
          this.toast('Configuracion agregada al producto');
          this.configuracionProductoInput = '';
          this.configuracionProductoSeleccionada = null;
          this.loadProductoConfiguraciones();
          this.getVariaciones(this.productoSeleccionado);
        }
      },
      (error) => console.error(error)
    );
  }

  toggleConfiguracionProducto(relacion: any): void {
    const activo = relacion.activo === 0 ? 1 : 0;
    this.v4.actualizarProductoConfiguracion(relacion.id, {
      producto: relacion.producto || this.productoSeleccionado?.id,
      configuracion: relacion.configuracion,
      activo
    }).subscribe(
      (data: any) => {
        if (data.success) {
          relacion.activo = activo;
          this.toast(activo ? 'Configuracion activa' : 'Configuracion inactiva');
          this.getVariaciones(this.productoSeleccionado);
        }
      },
      (error) => console.error(error)
    );
  }

  eliminarConfiguracionProducto(relacion: any): void {
    if (!confirm('Quitar configuracion del producto?')) {
      return;
    }
    this.v4.eliminarProductoConfiguracion(relacion.id).subscribe(
      (data: any) => {
        if (data.success) {
          this.toast('Configuracion quitada');
          this.loadProductoConfiguraciones();
          this.getVariaciones(this.productoSeleccionado);
        }
      },
      (error) => console.error(error)
    );
  }

  get variacionesFiltradas() {
    const term = this.filtroVariacion.toLowerCase();
    return this.variaciones.filter((v) => {
      const base = this.getVariacionBaseNombre(v).toLowerCase();
      return !term || base.includes(term);
    });
  }

  get productoTipoRelacion(): string {
    return (this.productoSeleccionado?.tipo || '').trim();
  }

  get variacionesBaseProductoDisponiblesFiltradas() {
    const term = this.filtroVariacionBase.toLowerCase();
    const tipoProducto = this.productoTipoRelacion.toLowerCase();
    const asignadas = this.variaciones.map((variacion) => Number(variacion.variacion));
    if (!tipoProducto) {
      return [];
    }

    return this.variacionesBase.filter((variacion) => {
      const tipoVariacion = this.getVariacionBaseTipo(variacion).toLowerCase();
      const texto = `${this.getVariacionBaseLabel(variacion)} ${variacion.nombre || ''}`.toLowerCase();
      const activa = variacion.activo === undefined || variacion.activo !== 0;
      return activa
        && tipoVariacion === tipoProducto
        && !asignadas.includes(Number(variacion.id))
        && (!term || texto.includes(term));
    });
  }

  isVariacionSeleccionada(id: any): boolean {
    return this.variacionesSeleccionadas.includes(Number(id));
  }

  toggleVariacionSeleccionada(id: any, checked: boolean): void {
    const variacionId = Number(id);
    if (!variacionId) {
      return;
    }
    if (checked && !this.isVariacionSeleccionada(variacionId)) {
      this.variacionesSeleccionadas.push(variacionId);
      return;
    }
    if (!checked) {
      this.variacionesSeleccionadas = this.variacionesSeleccionadas.filter((item) => Number(item) !== variacionId);
    }
  }

  seleccionarTodasVariacionesDisponibles(): void {
    const ids = this.variacionesBaseProductoDisponiblesFiltradas.map((variacion) => Number(variacion.id));
    this.variacionesSeleccionadas = Array.from(new Set([...this.variacionesSeleccionadas, ...ids]));
  }

  get configuracionesProductoFiltradas() {
    const term = this.filtroConfiguracionProducto.toLowerCase();
    return this.productoConfiguraciones.filter((relacion) => {
      const texto = `${this.getConfiguracionRelacionNombre(relacion)} ${this.getConfiguracionRelacionDescripcion(relacion)}`.toLowerCase();
      return !term || texto.includes(term);
    });
  }

  get configuracionesBaseDisponiblesProducto() {
    if (!this.productoVariacionConfigurando) {
      return [];
    }
    const term = this.configuracionProductoInput.toLowerCase();
    const asignadas = this.productoConfiguraciones
      .filter((relacion) => relacion.activo !== 0)
      .map((relacion) => Number(relacion.configuracion));
    return this.getConfiguracionesBaseDeVariacion(this.productoVariacionConfigurando.variacion).filter((config) => {
      const nombre = (config.configuracion || '').toLowerCase();
      const descripcion = (config.descripcion || '').toLowerCase();
      const label = this.getConfiguracionOptionLabel(config).toLowerCase();
      const activa = config.activo === undefined || config.activo !== 0;
      return activa && !asignadas.includes(Number(config.id)) && (!term || nombre.includes(term) || descripcion.includes(term) || label.includes(term));
    });
  }

  getVariacionBaseNombre(variacion: any): string {
    if (variacion.label) {
      return variacion.label;
    }
    if (variacion.variacion_nombre) {
      return this.formatVariacionLabel(variacion.variacion_nombre, variacion.variacion_tipo || variacion.tipo);
    }
    const vb = this.variacionesBase.find((v) => Number(v.id) === Number(variacion.variacion));
    return vb ? this.formatVariacionLabel(vb.nombre, vb.tipo) : '-';
  }

  getVariacionConfiguraciones(variacion: any): any[] {
    if (variacion.configuraciones) {
      return variacion.configuraciones;
    }
    const vb = this.variacionesBase.find((v) => Number(v.id) === Number(variacion.variacion));
    return vb?.configuraciones || [];
  }

  getConfiguracionesBaseDeVariacion(variacionId: any): any[] {
    const vb = this.variacionesBase.find((v) => Number(v.id) === Number(variacionId));
    return vb?.configuraciones || [];
  }

  getVariacionBaseTipo(variacion: any): string {
    return variacion?.tipo || variacion?.nombre || '';
  }

  getVariacionBaseLabel(variacion: any): string {
    return this.formatVariacionLabel(variacion?.nombre, this.getVariacionBaseTipo(variacion));
  }

  getConfiguracionOptionLabel(config: any): string {
    const variacion = config.variacion_label || this.getVariacionBaseNombre({
      variacion: config.variacion,
      variacion_nombre: config.variacion_nombre,
      variacion_tipo: config.variacion_tipo
    });
    const nombre = config.configuracion || '';
    const descripcion = config.descripcion || '';
    return `${variacion}: ${nombre}${descripcion ? ' - ' + descripcion : ''}`;
  }

  getConfiguracionRelacionNombre(relacion: any): string {
    if (relacion.configuracion_nombre) {
      return relacion.configuracion_nombre;
    }
    if (relacion.configuracion_detalle?.configuracion) {
      return relacion.configuracion_detalle.configuracion;
    }
    const config = this.getConfiguracionesBaseDeVariacion(relacion.variacion).find((item) => Number(item.id) === Number(relacion.configuracion));
    return config ? config.configuracion : '-';
  }

  getConfiguracionRelacionDescripcion(relacion: any): string {
    if (relacion.configuracion_detalle?.descripcion) {
      return relacion.configuracion_detalle.descripcion;
    }
    const config = this.getConfiguracionesBaseDeVariacion(relacion.variacion).find((item) => Number(item.id) === Number(relacion.configuracion));
    return config?.descripcion || '';
  }

  getConfiguracionRelacionImagen(relacion: any): string {
    const detalle = relacion.configuracion_detalle;
    const galeria = detalle?.imagenes || [];
    const activa = galeria.find((img) => img.activo !== 0);
    return this.buildImagePath(detalle?.imagen || activa?.imagen);
  }

  getConfiguracionRelacionFotos(relacion: any): number {
    const detalle = relacion.configuracion_detalle;
    return detalle?.imagenes?.length || 0;
  }

  abrirImagenes(modal: any, producto: any): void {
    this.productoSeleccionado = producto;
    this.productoImagenFiles = [];
    this.productoImagenForm = { titulo: '', orden: 0, activo: 1 };
    this.loadProductoImagenes(producto.id);
    this.modalService.open(modal, { ariaLabelledBy: 'modal-imagenes-producto', size: 'lg' });
  }

  loadProductoImagenes(productoId: number): void {
    this.loadingImagenes = true;
    this.v4.getProductoImagenes(productoId).subscribe(
      (data: any) => {
        this.loadingImagenes = false;
        if (data.success) {
          this.imagenesProducto = data.content || [];
        }
      },
      (error) => {
        this.loadingImagenes = false;
        console.error(error);
      }
    );
  }

  agregarImagenesProducto(): void {
    if (!this.productoSeleccionado || !this.productoImagenFiles.length) {
      this.toast('Seleccione imagenes', '#CA0B00');
      return;
    }
    let pendientes = this.productoImagenFiles.length;
    this.productoImagenFiles.forEach((file, index) => {
      this.v4.crearProductoImagen({
        producto: this.productoSeleccionado.id,
        titulo: this.productoImagenForm.titulo,
        orden: Number(this.productoImagenForm.orden || 0) + index,
        activo: this.productoImagenForm.activo,
        imagen: file
      }).subscribe(
        (data: any) => {
          pendientes -= 1;
          if (!data.success) {
            console.error(data.error);
          }
          if (pendientes === 0) {
            this.toast('Imagenes agregadas');
            this.productoImagenFiles = [];
            this.productoImagenForm = { titulo: '', orden: 0, activo: 1 };
            this.loadProductoImagenes(this.productoSeleccionado.id);
            this.getProductos();
          }
        },
        (error) => {
          pendientes -= 1;
          console.error(error);
          if (pendientes === 0) {
            this.loadProductoImagenes(this.productoSeleccionado.id);
          }
        }
      );
    });
  }

  toggleProductoImagen(imagen: any): void {
    const activo = imagen.activo === 0 ? 1 : 0;
    this.v4.actualizarProductoImagen(imagen.id, {
      producto: imagen.producto || this.productoSeleccionado?.id,
      titulo: imagen.titulo || '',
      orden: imagen.orden || 0,
      activo
    }).subscribe(
      (data: any) => {
        if (data.success) {
          imagen.activo = activo;
          this.toast(activo ? 'Imagen activa' : 'Imagen inactiva');
        }
      },
      (error) => console.error(error)
    );
  }

  eliminarProductoImagen(imagen: any): void {
    if (!confirm('Eliminar imagen?')) {
      return;
    }
    this.v4.eliminarProductoImagen(imagen.id).subscribe(
      (data: any) => {
        if (data.success) {
          this.toast('Imagen eliminada');
          this.loadProductoImagenes(this.productoSeleccionado.id);
          this.getProductos();
        }
      },
      (error) => console.error(error)
    );
  }

  onFileChangeNuevo(event: any): void {
    const file = event.target.files[0];
    this.formulario.imagen = file || null;
  }

  onFileChangeEditar(event: any): void {
    const file = event.target.files[0];
    this.formularioEdit.imagen = file || null;
  }

  onProductoImagenesChange(event: any): void {
    const files = event.target.files || [];
    this.productoImagenFiles = [];
    for (let i = 0; i < files.length; i += 1) {
      this.productoImagenFiles.push(files[i]);
    }
  }

  onConfiguracionProductoInputChange(value: string): void {
    this.configuracionProductoInput = value;
    this.configuracionProductoSeleccionada = null;
  }

  getProductoPrincipal(producto: any): string {
    const galeria = producto.imagenes || [];
    const activa = galeria.find((img) => img.activo !== 0);
    return this.buildImagePath(producto.imagen || activa?.imagen);
  }

  buildImagePath(imagen?: string): string {
    if (!imagen) {
      return this.defaultImage;
    }
    if (imagen.startsWith('http')) {
      return imagen;
    }
    return `${environment.BASE_URL}${imagen}`;
  }

  private getVariacionesBase(): void {
    this.v4.getVariacionesBase().subscribe(
      (data: any) => {
        if (data.success) {
          this.variacionesBase = data.content || [];
        }
      },
      (error) => console.error(error)
    );
  }

  private getTiposProductoCatalogo(): void {
    this.v4.getTiposProducto({ activo: 1 }).subscribe(
      (data: any) => {
        if (data.success) {
          this.tiposProductoCatalogo = data.content || [];
          this.ordenarTiposCatalogo();
        }
      },
      (error) => console.error(error)
    );
  }

  private aplicarTipoNuevo(nombre: string): void {
    if (this.tipoDestino === 'editar') {
      this.formularioEdit.tipo = nombre;
      return;
    }
    this.formulario.tipo = nombre;
  }

  private ordenarTiposCatalogo(): void {
    this.tiposProductoCatalogo = [...this.tiposProductoCatalogo].sort((a, b) =>
      String(a.nombre || '').localeCompare(String(b.nombre || ''))
    );
  }

  private getConfiguracionIdFromInput(value: string): number | null {
    const parsed = Number(String(value || '').split(' - ')[0]);
    if (!Number.isNaN(parsed) && parsed > 0) {
      return parsed;
    }
    const match = this.configuracionesBaseDisponiblesProducto.find((config) => {
      const texto = String(value || '').toLowerCase();
      return (config.configuracion || '').toLowerCase() === texto || this.getConfiguracionOptionLabel(config).toLowerCase() === texto;
    });
    return match ? Number(match.id) : null;
  }

  private formatVariacionLabel(nombre?: string, tipo?: string): string {
    const nombreValor = nombre || '';
    const tipoValor = tipo || '';
    if (nombreValor && tipoValor && nombreValor.toLowerCase() !== tipoValor.toLowerCase()) {
      return `${nombreValor} (${tipoValor})`;
    }
    return nombreValor || tipoValor || '-';
  }

  private getApiError(data: any): string {
    if (!data?.error) {
      return '';
    }
    if (typeof data.error === 'string') {
      return data.error;
    }
    const firstKey = Object.keys(data.error)[0];
    const firstValue = firstKey ? data.error[firstKey] : '';
    return Array.isArray(firstValue) ? firstValue[0] : String(firstValue || '');
  }

  private toast(title: string, color: string = '#4CAF50'): void {
    this.iziToast.show({
      title,
      titleColor: '#f8f8ff',
      color,
      position: 'topRight',
      closeOnEscape: true
    });
  }
}
